/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Table_Sellername1Inputs */

const id_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Penjual`)
};

const ms_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Penjual`)
};

const da_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sælgernavn`)
};

const de_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufername`)
};

const en_us2_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller Name`)
};

const es_es2_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del vendedor`)
};

const es_mx2_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del vendedor`)
};

const fil_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan ng Nagbebenta`)
};

const fr_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du vendeur`)
};

const it_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome venditore`)
};

const hu_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eladó neve`)
};

const nl_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkopersnaam`)
};

const no_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selgernavn`)
};

const pl_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa sprzedawcy`)
};

const pt_br2_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do vendedor`)
};

const pt_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do vendedor`)
};

const ro_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nume vânzător`)
};

const fi_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myyjän nimi`)
};

const sv_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säljarnamn`)
};

const vi_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên người bán`)
};

const tr_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı Adı`)
};

const cs_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno prodejce`)
};

const bg_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Име на продавач`)
};

const ru_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя продавца`)
};

const uk_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва продавця`)
};

const ar_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم البائع`)
};

const hi_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता का नाम`)
};

const th_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อผู้ขาย`)
};

const ja_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元名`)
};

const zh_cn2_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发行商名称`)
};

const zh_hant1_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發行商名稱`)
};

const ko_freebies_table_sellername1 = /** @type {(inputs: Freebies_Table_Sellername1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자명`)
};

/**
* | output |
* | --- |
* | "Seller Name" |
*
* @param {Freebies_Table_Sellername1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_table_sellername1 = /** @type {((inputs?: Freebies_Table_Sellername1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Table_Sellername1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_table_sellername1(inputs)
	if (locale === "ms") return ms_freebies_table_sellername1(inputs)
	if (locale === "da") return da_freebies_table_sellername1(inputs)
	if (locale === "de") return de_freebies_table_sellername1(inputs)
	if (locale === "en-US") return en_us2_freebies_table_sellername1(inputs)
	if (locale === "es-ES") return es_es2_freebies_table_sellername1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_table_sellername1(inputs)
	if (locale === "fil") return fil_freebies_table_sellername1(inputs)
	if (locale === "fr") return fr_freebies_table_sellername1(inputs)
	if (locale === "it") return it_freebies_table_sellername1(inputs)
	if (locale === "hu") return hu_freebies_table_sellername1(inputs)
	if (locale === "nl") return nl_freebies_table_sellername1(inputs)
	if (locale === "no") return no_freebies_table_sellername1(inputs)
	if (locale === "pl") return pl_freebies_table_sellername1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_table_sellername1(inputs)
	if (locale === "pt") return pt_freebies_table_sellername1(inputs)
	if (locale === "ro") return ro_freebies_table_sellername1(inputs)
	if (locale === "fi") return fi_freebies_table_sellername1(inputs)
	if (locale === "sv") return sv_freebies_table_sellername1(inputs)
	if (locale === "vi") return vi_freebies_table_sellername1(inputs)
	if (locale === "tr") return tr_freebies_table_sellername1(inputs)
	if (locale === "cs") return cs_freebies_table_sellername1(inputs)
	if (locale === "bg") return bg_freebies_table_sellername1(inputs)
	if (locale === "ru") return ru_freebies_table_sellername1(inputs)
	if (locale === "uk") return uk_freebies_table_sellername1(inputs)
	if (locale === "ar") return ar_freebies_table_sellername1(inputs)
	if (locale === "hi") return hi_freebies_table_sellername1(inputs)
	if (locale === "th") return th_freebies_table_sellername1(inputs)
	if (locale === "ja") return ja_freebies_table_sellername1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_table_sellername1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_table_sellername1(inputs)
	return ko_freebies_table_sellername1(inputs)
});
export { freebies_table_sellername1 as "freebies.table.sellerName" }